// import enum
import { StatusEnum } from "@/enum/status.enum.js";

export const state = {
  filterUser: {
    open_id: "",
    employee_id: "",
    name: "",
    email: "",
    groups: [],
    status: [],
    isFilter: false,
  },
};
export const mutations = {
  ADD_FILTER_USER: (state, data) => {
    state.filterUser = data;
    state.filterUser.isFilter = true;
  },
  CLEAR_FILTER_USER: (state) => {
    state.filterUser = {
      open_id: "",
      employee_id: "",
      name: "",
      email: "",
      groups: [],
      status: [],
    };
  },
};
export const getters = {
  GET_FILTER_USER: (state) => {
    return state.filterUser;
  },
};
export const actions = {
  ADD_FILTER_USER: ({ commit }, data) => {
    commit("ADD_FILTER_USER", data);
  },
  CLEAR_FILTER_USER: ({ commit }) => {
    commit("ADD_FILTER_USER");
  },
};
